import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';

const SignupStepIndicator = ({ step, total = 3, labels = [], modoOscuro, compact = false, tight = false }) => (
  <div className={tight ? 'mb-2' : compact ? 'mb-3 sm:mb-4' : 'mb-5 sm:mb-6'}>
    <div className="flex items-center justify-center">
      {Array.from({ length: total }, (_, i) => i + 1).map((stepNumber) => (
        <div key={stepNumber} className="flex items-center">
          <div
            className={`rounded-full flex items-center justify-center font-bold transition-all duration-300 ${
              compact ? 'w-8 h-8 text-xs' : 'w-10 h-10 text-sm shadow-lg'
            } ${
              step >= stepNumber
                ? 'bg-[#1F80FF] text-white'
                : modoOscuro
                  ? 'bg-gray-700 text-gray-400'
                  : 'bg-gray-200 text-gray-500'
            }`}
          >
            {step > stepNumber ? (
              <FiCheckCircle className={compact ? 'w-4 h-4' : 'w-5 h-5'} />
            ) : (
              stepNumber
            )}
          </div>
          {stepNumber < total && (
            <div
              className={`h-0.5 sm:h-1 mx-1.5 sm:mx-2 transition-all duration-300 ${
                compact ? 'w-8 sm:w-12' : 'w-12 sm:w-16'
              } ${step > stepNumber ? 'bg-[#1F80FF]' : modoOscuro ? 'bg-gray-700' : 'bg-gray-200'}`}
            />
          )}
        </div>
      ))}
    </div>
    {labels.length > 0 && (
      <p
        className={`text-center mt-1 ${compact ? 'text-[11px]' : 'text-xs'} ${
          modoOscuro ? 'text-gray-400' : 'text-gray-500'
        }`}
      >
        {labels[step - 1]}
      </p>
    )}
  </div>
);

export default SignupStepIndicator;
